var map = {
	"./amplify-amazon-button_5.entry.js": [
		"77e1",
		"chunk-6c266c42"
	],
	"./amplify-auth-fields_9.entry.js": [
		"2689",
		"chunk-5d3cd8de"
	],
	"./amplify-authenticator.entry.js": [
		"b836",
		"chunk-6302b2f5"
	],
	"./amplify-button_3.entry.js": [
		"efa9",
		"chunk-4173f795"
	],
	"./amplify-checkbox.entry.js": [
		"db86",
		"chunk-2d228cf2"
	],
	"./amplify-confirm-sign-in_8.entry.js": [
		"be17",
		"chunk-30e59445"
	],
	"./amplify-container.entry.js": [
		"a72f",
		"chunk-2d208de0"
	],
	"./amplify-federated-buttons_2.entry.js": [
		"644c",
		"chunk-227f88fe"
	],
	"./amplify-federated-sign-in.entry.js": [
		"a81f",
		"chunk-35d3f713"
	],
	"./amplify-form-field_4.entry.js": [
		"f988",
		"chunk-2d22dbc9"
	],
	"./amplify-greetings.entry.js": [
		"57dd",
		"chunk-7036fe2c"
	],
	"./amplify-icon-button.entry.js": [
		"182d",
		"chunk-2d0abfcf"
	],
	"./amplify-icon.entry.js": [
		"b8f5",
		"chunk-e5e622b4"
	],
	"./amplify-link.entry.js": [
		"f482",
		"chunk-2d22c8fe"
	],
	"./amplify-nav_2.entry.js": [
		"23a0",
		"chunk-3151a51e"
	],
	"./amplify-photo-picker.entry.js": [
		"c4f1",
		"chunk-72398c84"
	],
	"./amplify-picker.entry.js": [
		"d040",
		"chunk-7239ebd0"
	],
	"./amplify-radio-button_2.entry.js": [
		"a4b9",
		"chunk-1213b6f8"
	],
	"./amplify-s3-album.entry.js": [
		"4e6f",
		"chunk-3e6178c0"
	],
	"./amplify-s3-image-picker.entry.js": [
		"b90a",
		"chunk-1e17a2b9"
	],
	"./amplify-s3-image.entry.js": [
		"76ad",
		"chunk-336c8a11"
	],
	"./amplify-s3-text-picker.entry.js": [
		"5af2",
		"chunk-47fce0e9"
	],
	"./amplify-s3-text.entry.js": [
		"dce0",
		"chunk-7f9afdd7"
	],
	"./amplify-select-mfa-type.entry.js": [
		"fef4",
		"chunk-6d544b66"
	],
	"./amplify-sign-in-button.entry.js": [
		"7358",
		"chunk-f994c8e8"
	],
	"./amplify-tooltip.entry.js": [
		"1faa",
		"chunk-2d0b722b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "521b";
module.exports = webpackAsyncContext;